module.exports = __webpack_public_path__ + "img/location_blue.2555ed60.png";